import Pillarbox from '../pillarbox.js';
import pillarboxLang from './rm.json';

Pillarbox.addLanguage('rm', {
  ...pillarboxLang,
});
